export default "__VITE_ASSET__Xg934jBM__"